import moment from "moment";
import { Box, Button, Card, CardContent, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import CustomModal from "../../../shared/CustomModal";
import DashboardPerformanceFormAdd from "./DashboardPerformanceFormAdd";
import { getPerformanceDetail } from "../dashboard.api";
import { RootState } from "../../../store";
import { useDispatch, useSelector } from "react-redux";
import { CardHeader, Grid, Table, TableBody, TableCell, TableRow } from "@mui/material";
import { Pie } from "react-chartjs-2";
import DashboardPerformanceFormEdit from "./DashboardPerformanceFormEdit";

export default function DashboardPerformance() {
    const dispatch = useDispatch();
    const performanceDetail = useSelector((state: RootState) => state.dashboard.performanceDetail);
    const loading = useSelector((state: RootState) => state.dashboard.loading);
    const { teamList } = useSelector((state: RootState) => state.team);
    const [selectedDate, setSelectedDate] = useState<string>("");
    const [openAddModal, setOpenAddModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);

    useEffect(() => {
        setSelectedDate(moment().format("YYYY-MM-DD"));
    }, []);

    useEffect(() => {
        if (selectedDate) {
            dispatch<any>(getPerformanceDetail(selectedDate));
        }
    }, [selectedDate, dispatch]);

    const handleCloseModal = (isReload: boolean) => {
        setOpenAddModal(false)
        setOpenEditModal(false);
        if (isReload) {
            dispatch<any>(getPerformanceDetail(selectedDate));
        }
    }

    // Helper to get value from performanceDetail by team name
    const getPerfValue = (teamName: string, key: string) => {
        const found = Array.isArray(performanceDetail) && performanceDetail.find((item: any) => item.team_name === teamName);
        return found ? found[key] : 0;
    };

    return (
        <Card>
            <CustomModal
                open={openAddModal}
                onClose={() => setOpenAddModal(false)}
                title="Input Daily Jobs"
                component={<DashboardPerformanceFormAdd date={selectedDate} onClose={handleCloseModal} />}
            />
            <CustomModal
                open={openEditModal}
                onClose={() => setOpenEditModal(false)}
                title="Edit Daily Jobs"
                component={<DashboardPerformanceFormEdit date={selectedDate} onClose={handleCloseModal} />}
            />
            <CardContent>
                <Box display="flex" alignItems="center" justifyContent={"space-between"}>
                    <Button variant="contained" onClick={() => setOpenAddModal(true)}>Input Daily Jobs</Button>
                    <Box display={"flex"} alignItems="center" gap={1}>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <DesktopDatePicker
                                label="Date"
                                inputFormat="MM/DD/YYYY"
                                value={selectedDate}
                                onChange={(value) => setSelectedDate(moment(value).format('YYYY-MM-DD'))}
                                renderInput={(params) => <TextField {...params} size="small" required />}
                            />
                        </LocalizationProvider>
                        <Button variant="contained" onClick={() => setOpenEditModal(true)}>Edit</Button>
                    </Box>
                </Box>
                <Grid container spacing={2} mt={1}>
                    <Grid item xs={8}>
                        {loading ? (
                            <div>Loading...</div>
                        ) : (
                            <Grid container spacing={2}>
                                {teamList.map((team: any) => (
                                    <Grid item xs={4} key={team.id}>
                                        <Card variant="outlined">
                                            <CardHeader title={team.name} />
                                            <CardContent>
                                                <Table size="small">
                                                    <TableBody>
                                                        <TableRow>
                                                            <TableCell sx={{ border: 0 }}>New Today</TableCell>
                                                            <TableCell sx={{ border: 0 }}>:</TableCell>
                                                            <TableCell sx={{ border: 0 }}>{getPerfValue(team.name, "value_new_today")}</TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell sx={{ border: 0 }}>New This Week</TableCell>
                                                            <TableCell sx={{ border: 0 }}>:</TableCell>
                                                            <TableCell sx={{ border: 0 }}>{getPerfValue(team.name, "value_new_week")}</TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell sx={{ border: 0 }}>Complete Today</TableCell>
                                                            <TableCell sx={{ border: 0 }}>:</TableCell>
                                                            <TableCell sx={{ border: 0 }}>{getPerfValue(team.name, "value_complete_today")}</TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell sx={{ border: 0 }}>Complete This Week</TableCell>
                                                            <TableCell sx={{ border: 0 }}>:</TableCell>
                                                            <TableCell sx={{ border: 0 }}>{getPerfValue(team.name, "value_complete_week")}</TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                ))}
                            </Grid>
                        )}
                    </Grid>
                    <Grid item xs={4}>
                        <Pie
                            data={{
                                labels: ["New This Week", "Complete This Week"],
                                datasets: [
                                    {
                                        data: [
                                            Array.isArray(performanceDetail) ? performanceDetail.reduce((total: number, item: any) => total + (item.value_new_week || 0), 0) : 0,
                                            Array.isArray(performanceDetail) ? performanceDetail.reduce((total: number, item: any) => total + (item.value_complete_week || 0), 0) : 0
                                        ],
                                        backgroundColor: ["#42a5f5", "#66bb6a"]
                                    }
                                ]
                            }}
                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}